module.exports = __webpack_public_path__ + "static/img/china-telecom.77cf811.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/partners/china-telecom.png
// module id = YLUt
// module chunks = 1 2